import { createContext, useContext } from 'react';
import type { SpecificNavigationProp } from 'app/types/navigation';
import type { NewScreenParams } from './index';

// Auxiliary screens return their selection to the persistent publishing tab.
export const CreationTabContext = createContext(false);
export const useCreationTab = () => useContext(CreationTabContext);

export function returnToCreationTab(navigation: SpecificNavigationProp, params: NewScreenParams) {
  navigation.navigate('main', { screen: 'publish', params: { ...params, creationTab: 'manual' } }, { pop: true });
}
